import { Paragraph, Small } from 'components/Typography';
const InvoiceColumnShape = [
    {
        Header: 'No',
        accessor: 'number',
    },
    {
        Header: 'Event Name',
        accessor: 'eventName',
        Cell: ({ value }) => (
            <Paragraph fontSize={13} color="text.secondary">
                {value}
            </Paragraph>
        ),
    },
    {
        Header: 'Location',
        accessor: 'location',
        Cell: ({ value }) => <Small color="text.secondary">{value}</Small>,
    },
    {
        Header: 'Date',
        accessor: 'date',
        Cell: ({ value }) => <Small color="text.secondary">{value}</Small>,
    },
];
export default InvoiceColumnShape;
